import { SharedModule } from "@bb-vendure/admin-ui/core";
import { Component, ContentChild, TemplateRef } from "@angular/core";

@Component({
  selector: "expand-div",
  standalone: true,
  imports: [SharedModule],
  template:``,
})
export default class ExpandingDivComponent {
  @ContentChild(TemplateRef, { static: false }) template: TemplateRef<any>;
}
